import { render, staticRenderFns } from "./item_container.vue?vue&type=template&id=6f18a537&scoped=true&"
import script from "./item_container.vue?vue&type=script&lang=js&"
export * from "./item_container.vue?vue&type=script&lang=js&"
import style0 from "./item_container.vue?vue&type=style&index=0&id=6f18a537&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f18a537",
  null
  
)

export default component.exports